module.exports = __webpack_public_path__ + "img/mas.38039a7b.svg";